import { render } from "./startGame.vue?vue&type=template&id=71fc322e&scoped=true"
import script from "./startGame.vue?vue&type=script&lang=js"
export * from "./startGame.vue?vue&type=script&lang=js"

import "./startGame.vue?vue&type=style&index=0&id=71fc322e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fc322e"]])

export default __exports__